module.exports = __webpack_public_path__ + "img/20_22.5f46eb82.png";